import BaseUrl from '@/api/BaseUrl';
import Headers from '@/api/Headers';
import ENDPOINTS from '@/api/endpoints';

// NOTE: key must live in the options object — a third useFetch argument is
// ignored, which previously made the request fire twice (once on setup, once
// via execute) with no cache key. The fetch fires once on creation; callers
// await the returned promise and use `execute` only to refresh (FEP-7383)
const useEventData = (id) => {
  const eventDataUrl = `${BaseUrl.get(ENDPOINTS.EVENTS.GET_EVENT_PAGE_CONFIG)}${
    ENDPOINTS.EVENTS.GET_EVENT_PAGE_CONFIG
  }?event_id=${id}`;

  return useFetch(eventDataUrl, {
    headers: Headers,
    key: `event-config-${id}`,
  });
};

export default useEventData;
